import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Divider from '@src/common/components/Divider';
import Style from './index.css';
import { getModuleByName, getThumbnailFromRecommend } from '@src/common/utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { formatImage } from '@ifeng/public_method';
import 'swiper/css';

const ShortVideos = props => {
    const { content } = props;
    const [current, setCurrent] = useState(0);
    const [isShowVideo, setIsShowVideo] = useState(false);
    const videoRef = useRef(null);

    const shortVideoList = getModuleByName(content, '精彩短视频')?.data.articleList;

    const GetSplitVideoList = () => {
        const arr = [];
        let index = 0;

        while (index <= shortVideoList.length) {
            arr.push(
                shortVideoList.slice(index, index + 4 < shortVideoList.length ? index + 4 : shortVideoList.length),
            );
            index += 4;
        }

        return arr;
    };

    const changeVideoItem = (index, i) => {
        setCurrent(index * 4 + i);
        setIsShowVideo(false);
    };

    const handleVideoPlay = () => {
        setIsShowVideo(true);
    };

    useEffect(
        () => {
            if (videoRef.current && isShowVideo) {
                videoRef.current.play();
            }
        },
        [isShowVideo, current],
    );

    return (
        <div>
            <Divider />
            <div className={Style.shortVideos}>
                <div className={Style.previewPart}>
                    {!isShowVideo ? (
                        <div className={Style.videoItem} onClick={handleVideoPlay}>
                            <img
                                className={Style.poster}
                                src={formatImage(getThumbnailFromRecommend(shortVideoList[current]), 440, 320)}
                                alt=""
                            />
                            <div className={Style.title}>{shortVideoList[current].title}</div>
                            <img
                                className={Style.play}
                                src="https://x2.ifengimg.com/fe/shank/custom/play2.8e0e05eb.png"
                                alt="play"
                            />
                        </div>
                    ) : (
                        <video
                            src={shortVideoList[current].videoPlayUrl}
                            ref={videoRef}
                            controls
                            className={Style.videoPlay}
                        />
                    )}
                </div>
                <div className={Style.swiperPart}>
                    <Swiper
                        modules={[Navigation]}
                        navigation={{
                            prevEl: `.${Style.prev}`,
                            nextEl: `.${Style.next}`,
                        }}
                        style={{ width: '430px' }}>
                        {GetSplitVideoList().map((videoList, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <div className={Style.swiperItem}>
                                        {videoList.map((video, i) => {
                                            return (
                                                <div
                                                    className={`${Style.cell} ${
                                                        current === index * 4 + i ? Style.active : ''
                                                    }`}
                                                    key={`${index}_${i}`}
                                                    onClick={() => changeVideoItem(index, i)}>
                                                    <div className={Style.videoItem}>
                                                        <img
                                                            className={Style.poster}
                                                            src={getThumbnailFromRecommend(video)}
                                                            alt=""
                                                        />
                                                        <div className={Style.title}>{video.title}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                    <div className={`${Style.navigation} ${Style.prev}`} />
                    <div className={`${Style.navigation} ${Style.next}`} />
                </div>
            </div>
            <Divider />
        </div>
    );
};

ShortVideos.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(ShortVideos);
